var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isSrcIconEmpty)?_c('img',{staticStyle:{"margin-right":"15px"},style:(_vm.styleEmail),attrs:{"src":_vm.srcIcon,"alt":""}}):_c('div',{staticStyle:{"margin-right":"15px","width":"18px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }